import React, { Fragment } from 'react';
import './TappableStayComponentCard.scss'; 

const TappableStayComponentCard = ({ 
    actions,
    componentID,
    componentRating,
    displayName,
    handleTextareaToggle
}) =>
    <Fragment>
        <section className='tap-rating-component__top'>
            {displayName}
        </section>

        <section className='tap-rating-component__bottom'>
            <a
                className={`tap-rating-component__button sad ${componentRating === 0 ? 'active' : ''}`}
                onClick={() => {
                    actions.setComponentAnswer({
                        id: componentID,
                        rating: 0
                    })
                    
                    handleTextareaToggle();
                }}
            />
            <a
                className={`tap-rating-component__button happy ${componentRating === 1 ? 'active' : ''}`}
                onClick={() =>
                    actions.setComponentAnswer({
                        id: componentID,
                        rating: 1
                    })
                }
            />
            <a
                className={`tap-rating-component__button love ${componentRating === 2 ? 'active' : ''}`}
                onClick={() =>
                    actions.setComponentAnswer({
                        id: componentID,
                        rating: 2
                    })
                }
            />
        </section>
    </Fragment>

export default TappableStayComponentCard;


// WEBPACK FOOTER //
// ./application/components/TappableStayComponentCard/TappableStayComponentCard.jsx